import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  TextCustomFieldFormData,
  TextCustomFieldInputData,
  textCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/textCustomFieldSchema.ts';
import useCreateCustomField from '@/features/dashboard/tourCustomFields/hooks/useCreateCustomField.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import TextCustomFieldForm from '@/features/dashboard/tourCustomFields/components/TextCustomFieldForm.tsx';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

const TextCustomFieldAddModal = ({ onClose }: { onClose: () => void }) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<TextCustomFieldInputData>({
    resolver: debugZodResolver(textCustomFieldSchema),
    defaultValues: {
      type: FieldType.TEXT,
    },
  });

  const createCustomField = useCreateCustomField(tourId);

  const handleSubmit = (data: TextCustomFieldFormData) => {
    createCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Skonfiguruj pole tekstowe" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <TextCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default TextCustomFieldAddModal;
